import React from 'react';
import { Redirect } from 'react-router-dom';
import {
  clearResetIdleTime,
  routeIsAuthorized,
} from '../legacy/containers/Auth';
import { LOGIN_ERROR_MESSAGES, ROUTES } from '../legacy/constants';
import { updateLoginError } from '../legacy/pages/Login/module';
import { updatePreviousLocation } from '../legacy/store/appReducer';

const RoutesAuthorizationChecker = props => {
  const { authorizationType, location, dispatch } = props;
  const { pathname } = location;
  const isAuthorized = dispatch(routeIsAuthorized(authorizationType, pathname));

  if (!isAuthorized && !pathname.startsWith(ROUTES.LOGIN)) {
    clearResetIdleTime();
    dispatch(updateLoginError(LOGIN_ERROR_MESSAGES.ROUTE_PERMISSION_DENIED));
    dispatch(updatePreviousLocation(location));
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: location },
        }}
      />
    );
  }

  return [props.children];
};

export default RoutesAuthorizationChecker;



// WEBPACK FOOTER //
// ./src/auth/RoutesAuthorizationChecker.jsx